<kendo-grid [kendoGridBinding]="revisionHistoryList" [sortable]="false" [resizable]="false" [reorderable]="false" [pageable]="false" id="grvStatusList">
  <kendo-grid-column title="Sl.No." filterable="false" [width]="60">
      <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
          {{rowIndex+1}}
      </ng-template>
  </kendo-grid-column>
  <kendo-grid-column title="Rev.No" field="revision" [width]="60">
      <ng-template kendoGridCellTemplate let-dataItem>
          <span class="no-wrap" eipTooltip="{{dataItem.revision}}" eipTooltipPosition="auto">{{dataItem.revision}}</span>
      </ng-template>
  </kendo-grid-column>
  <kendo-grid-column title="Status" filterable="false" [width]="100">
      <ng-template kendoGridCellTemplate let-dataItem>
          <span class="no-wrap" eipTooltip="{{dataItem.docStatusDesc}}" eipTooltipPosition="auto">
              {{dataItem.docStatusDesc}}
          </span>
      </ng-template>
  </kendo-grid-column>
  <kendo-grid-column title="Created By" filterable="false" [width]="100">
      <ng-template kendoGridCellTemplate let-dataItem>
          <span class="no-wrap" eipTooltip="{{dataItem.createdByName}}" eipTooltipPosition="auto">
              {{dataItem.createdByName}}
          </span>
      </ng-template>
  </kendo-grid-column>
  <kendo-grid-column title="Authorized By" filterable="false" [width]="100">
      <ng-template kendoGridCellTemplate let-dataItem>
          <span class="no-wrap" eipTooltip="{{dataItem.authorizedByName}}" eipTooltipPosition="auto">{{dataItem.authorizedByName}}</span>
      </ng-template>
  </kendo-grid-column>
  <kendo-grid-column title="Revised On" field="revisedOn" [width]="100" filter="date" format="{0:dd-MMM-yyyy}">
      <ng-template kendoGridCellTemplate let-dataItem>
          <span class="no-wrap" eipTooltip="{{dataItem.revisedOn| date:'dd-MMM-yyyy'}}" eipTooltipPosition="auto">{{dataItem.revisedOn| date:'dd-MMM-yyyy'}}</span>
      </ng-template>
  </kendo-grid-column>
  <kendo-grid-column title="Revision Category" field="revCategoryDesc" [width]="100">
      <ng-template kendoGridCellTemplate let-dataItem>
          <span class="no-wrap" eipTooltip="{{dataItem.revCategoryDesc}}" eipTooltipPosition="auto">
              {{dataItem.revCategoryDesc}}
          </span>
      </ng-template>
  </kendo-grid-column>
  <kendo-grid-column title="Print Size" field="printSizeDesc" [width]="100">
      <ng-template kendoGridCellTemplate let-dataItem>
          <span class="no-wrap" eipTooltip="{{dataItem.printSizeDesc}}" eipTooltipPosition="auto">
              {{dataItem.printSizeDesc}}
          </span>
      </ng-template>
  </kendo-grid-column>
  <kendo-grid-column title="No Of Sheets" field="noOfSheets" [width]="100">
      <ng-template kendoGridCellTemplate let-dataItem>
          <span class="no-wrap" eipTooltip="{{dataItem.noOfSheets}}" eipTooltipPosition="auto">
              {{dataItem.noOfSheets}}
          </span>
      </ng-template>
  </kendo-grid-column>
</kendo-grid>